"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateUnifiedCoefficient = calculateUnifiedCoefficient;
exports.calculateAverageUnifiedCoefficient = calculateAverageUnifiedCoefficient;
const value_checkers_1 = require("../value-checkers");
const roundToDecimalPlaces_1 = require("./roundToDecimalPlaces");
/**
 * Calculates unified coefficient from price coefficient and fee coefficient.
 * Uses hardcoded weight of 0.75 for the price and 0.25 for the fee so it's not 100% comparable to real price calculation.
 *
 * @param priceAdjustmentCoefficient - The price adjustment coefficient
 * @param feeAdjustmentCoefficient - The fee adjustment coefficient
 * @returns The weighted unified coefficient
 *
 */
function calculateUnifiedCoefficient(priceAdjustmentCoefficient, feeAdjustmentCoefficient) {
    if ((0, value_checkers_1.isUndefinedOrNull)(priceAdjustmentCoefficient)) {
        // eslint-disable-next-line no-param-reassign
        priceAdjustmentCoefficient = 1;
    }
    if ((0, value_checkers_1.isUndefinedOrNull)(feeAdjustmentCoefficient)) {
        return (0, roundToDecimalPlaces_1.roundToDecimalPlaces)(priceAdjustmentCoefficient, 2);
    }
    const unifiedCoefficient = 0.75 * priceAdjustmentCoefficient + 0.25 * feeAdjustmentCoefficient;
    return (0, roundToDecimalPlaces_1.roundToDecimalPlaces)(unifiedCoefficient, 2);
}
/**
 * Calculates average unified coefficient for a list of price adjustment coefficient - fee adjustment coefficient pairs.
 *
 * @param coefficients - The list of coefficient pairs
 * @returns The average unified coefficient
 *
 */
function calculateAverageUnifiedCoefficient(coefficients) {
    if (!coefficients.length) {
        return 1;
    }
    const coefficientSum = coefficients.reduce((sum, coefficient) => sum + calculateUnifiedCoefficient(coefficient.priceAdjustmentCoefficient, coefficient.feeAdjustmentCoefficient), 0);
    return (0, roundToDecimalPlaces_1.roundToDecimalPlaces)(coefficientSum / coefficients.length, 2);
}
//# sourceMappingURL=calculateUnifiedCoefficient.js.map